<main>
  <loading-overlay [isLoading]="isLoading() > 0 || !enumsReady()" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Businesses_Title' | translateWF: 'Businesses' }}</h1>
        @if (!isReadOnly) {
          <div class="page__title_buttons">
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'Businesses_Title' | translateWF: 'Businesses'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="businesses()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="code">
                  {{ 'Code' | translateWF: 'Code' }}
                  <p-sortIcon field="code" />
                </th>
                <th pSortableColumn="name">
                  {{ 'Name' | translateWF: 'Name' }}
                  <p-sortIcon field="name" />
                </th>
                <th>
                  {{ 'Business_Type' | translateWF: 'Business Type' }}
                </th>
                @if (canAssignSites) {
                  <th>
                    {{ 'Sites' | translateWF: 'Sites' }}
                  </th>
                }
                <th pSortableColumn="createdDate">
                  {{ 'Date_Created' | translateWF: 'Date Created' }}
                  <p-sortIcon field="createdDate" />
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let business = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="redirectToDetails(business.id)">{{ business.code }}</a>
                </td>
                <td>{{ business.name }}</td>
                <td>{{ getBusinessTypes(business.businessTypes) }}</td>
                @if (canAssignSites) {
                  <td>{{ getAssignedSiteNames(business) }}</td>
                }
                <td>{{ business.createdDate | date: 'dd/MM/yyyy' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="canAssignSites ? 5 : 4">
                  {{ 'Businesses_Not_Found' | translateWF: 'Businesses not found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
